import {Injectable} from '@angular/core';
import {API_URLS} from 'src/environments/env-routes';
import {APIHelper} from 'src/shared/services/api-helper/api-helper.service';

@Injectable({
  providedIn: 'root'
})
export class TrashcanService {
  constructor(private api: APIHelper) {}

  public getDeletedItems() {
    const args =
      '?skipCount=0&include=path%2Cproperties%2CallowableOperations%2Cpermissions%2CaspectNames';
    return this.api.requestApi({
      action: API_URLS.trashcan.getDeletedItems,
      queryArgs: args
    });
  }
  public restore(id: string) {
    return this.api.requestApi({
      action: API_URLS.trashcan.restore.replace(':nodeId', id),
      method: 'POST',
      datas: ''
    });
  }
  public deleteforever(id: string) {
    return this.api.requestApi({
      action: API_URLS.trashcan.deleteforever.replace(':nodeId', id),
      method: 'DELETE'
    });
  }
  public deleteall(){
    return this.api.requestApi({
      action: API_URLS.trashcan.deleteall,
      method: 'DELETE'
    });
  }
}
